import { render, staticRenderFns } from "./applyRoomDiscountRecord.vue?vue&type=template&id=2a920f3b"
import script from "./applyRoomDiscountRecord.vue?vue&type=script&lang=js"
export * from "./applyRoomDiscountRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports